










































































































































import { Component, Watch, Vue } from "vue-property-decorator";
import { GuardileoVueComponent } from "@/lib";
import { PageStore, PageStores } from "@/store/modules/page-store";
import { containsWoCaseMultipleFn } from "@/helper/global-helper";
import Vorfallmanagement from "./api/Vorfallmanagement";
import VorfallmanagementApi from "./api/api-vfmt";
import { vm } from "@/main";
import GesamtansichtVfmtVue from "./components/Gesamtansicht-vfmt.vue";
import DebugVfmtVue from "./components/Debug-vfmt.vue";
import UserNameDisplay from "@/components/UserNameDisplay.vue";

Vue.component("DebugVfmt", DebugVfmtVue);

@Component({
  components: {
    UserNameDisplay,
  },
})
export default class extends GuardileoVueComponent {
  private api = new VorfallmanagementApi();
  private pageStore: PageStore = PageStores.Vorfallmanagement;

  private sortFunc = (a: Vorfallmanagement.Vorfall.Info[]) => a;
  public filter: string = "";

  private items: Vorfallmanagement.Vorfall.Info[] = [];
  private get filteredItems() {
    const prefiltered = this.items.filter(
      (c) =>
        containsWoCaseMultipleFn(
          this.pageStore.filter,
          c.BezeichnungVorfall,
          c.LetzterBearbeiterName,
          c.LaufendeNummer + ""
        ) && this.pageStore.selected.find((a) => a === c.Status)
    );
    return this.sortFunc(prefiltered);
  }

  changeSortFunction(sortFunc: <T>(a: T) => T) {
    this.sortFunc = sortFunc;
  }

  async mounted() {
    await this.reload();
    this.status_loading = false;
  }

  async reload() {
    const data = await this.guard_status(
      async () => await this.api.GetVorfaelle()
    );
    this.items = data;
  }
  get darf_erstellen(): boolean {
    return (
      this.hat_Berechtigung("Vorfallmanagement_Vorfall_bearbeiten_voll") ||
      this.hat_Berechtigung(
        "Vorfallmanagement_Vorfall_bearbeiten_eingeschraenkt"
      )
    );
  }

  isAbgeschlossen(vorfall: Vorfallmanagement.Vorfall.Info): boolean {
    return vorfall.Status === Vorfallmanagement.Vorfall.Status.Abgeschlossen;
  }

  getFormattedDifferenceHHMM(start: Date | number, ende: Date | number) {
    const difference = +ende - +start;
    const minutes = difference / 1000 / 60;
    let overhang = minutes % 60;
    let hours = (minutes - overhang) / 60;

    if (hours <= -72) {
      hours = -72;
      overhang = 0;
    }

    const hoursString = hours.toLocaleString("de-de", {
      minimumIntegerDigits: 2,
      maximumFractionDigits: 0,
    });

    let overhangString = overhang.toLocaleString("de-de", {
      minimumIntegerDigits: 2,
      maximumFractionDigits: 0,
    });

    overhangString = overhangString.replace("-", "");

    return `${hoursString}:${overhangString}`;
  }

  showGesamtansicht(id: number) {
    vm.$modal.show(
      GesamtansichtVfmtVue,
      { id },
      { width: "80%", height: "80%", scrollable: true }
    );
  }
}
